import { Css, ScrollableContent } from "@homebound/beam";
import { useParams } from "react-router";
import { useLotPartitionDocumentsQuery } from "src/generated/graphql-types";
import { PageHeader } from "src/routes/layout/PageHeader";
import { queryResult } from "src/utils/queryResult";
import { createLotDetailsUrl } from "src/RouteUrls";
import { LotPartitionDocumentsTable } from "./LotPartitionDocumentsTable";

export function LotPartitionDocumentsPage() {
  const { lotId, lotPartitionId } = useParams<{ lotId: string; lotPartitionId: string }>();
  const query = useLotPartitionDocumentsQuery({ variables: { lotPartitionId } });

  return queryResult(query, ({ lotPartitions }) => {
    const lotPartition = lotPartitions[0];
    const lot = lotPartition.lot;
    const title = `${lot.address?.street1} - Partition ${lotPartitionId}`;

    return (
      <>
        <PageHeader title={title} backButton={createLotDetailsUrl(lotId)} />
        <ScrollableContent>
          <div css={Css.py2.$}>
            <LotPartitionDocumentsTable lotPartitionId={lotPartitionId} lotId={lotId} />
          </div>
        </ScrollableContent>
      </>
    );
  });
}
